import {
  action, makeAutoObservable, observable, runInAction, when,
} from 'mobx';
import { GTMApi } from '@gamiphy/gamix-modules/integrations/gtm';
import { GTMEvent } from '@gamiphy/bl/integrations/gtm';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { injectGtmScript } from './utils';

class IntegrationsStore {
    @observable initialized = false;

    @observable gtmDataLayer?: Array<unknown>;

    constructor() {
      makeAutoObservable(this);

      void this.initialize();
    }

    @action
    public async initialize(): Promise<void> {
      await when(() => AppStore.initialized);

      await this.initializeGTM();

      runInAction(() => {
        this.initialized = true;
      });
    }

    @action
    public async initializeGTM(): Promise<void> {
      const gtm = await GTMApi.getGTM();

      if (gtm) {
        this.gtmDataLayer = injectGtmScript('gamiphyDataLayer', gtm.id);
      }
    }

    @action
    public async trackGTMEvent(event: GTMEvent): Promise<void> {
      // Wait for the GTM to be loaded
      await when(() => !!this.gtmDataLayer);

      this.gtmDataLayer?.push({
        ...event,
      });
    }
}

export default new IntegrationsStore();
